import { Box, Button, Paper } from "@mui/material";
import AceEditor from "react-ace";
import PageHeader from "../page-header/PageHeader";

import "ace-builds/src-noconflict/mode-xml";
import "ace-builds/src-noconflict/theme-monokai";

function formatarXml(xml) {
  let nivel = 0;
  return xml
    .replace(/>\s*</g, "><")
    .replace(/(>)(<)(\/?)/g, "$1\n$2$3")
    .split("\n")
    .map((linha) => {
      if (/^<\//.test(linha)) nivel = Math.max(nivel - 1, 0);
      const formatada = `${"  ".repeat(nivel)}${linha}`;
      if (/^<[^!?/][^>]*[^/]?>$/.test(linha)) nivel += 1;
      return formatada;
    })
    .join("\n");
}

function XmlEnviadoPanel({ xml = "", nomeArquivo = "evento.xml", loading }) {
  function baixar() {
    const url = window.URL.createObjectURL(
      new Blob([xml], { type: "application/xml;charset=utf-8" })
    );
    const link = document.createElement("a");
    link.href = url;
    link.download = nomeArquivo;
    link.click();
    window.URL.revokeObjectURL(url);
  }

  return (
    <Box padding={2} paddingTop={0} component={Paper}>
      <PageHeader
        primary="XML enviado"
        secondary="Snapshot original recebido e armazenado de forma cifrada pelo Gateway"
        loading={loading}
        commands={[
          <Button variant="outlined" onClick={baixar} disabled={!xml}>
            Baixar
          </Button>
        ]}
      />
      <AceEditor
        mode="xml"
        theme="monokai"
        value={formatarXml(xml)}
        name="xml-enviado-editor"
        readOnly
        width="100%"
        height="460px"
        editorProps={{ $blockScrolling: true }}
        setOptions={{ showLineNumbers: true, tabSize: 2, useWorker: false }}
      />
    </Box>
  );
}

export default XmlEnviadoPanel;
